export default __webpack_public_path__ + "static/media/wechatpayGrey.fd194bf6.svg";